export default function PieLoading(){
    return (
        <div className="flex justify-center items-center gap-8">
            <div className="w-60 h-60 rounded-full bg-gray-300 animate-pulse"></div>
            <div className="flex flex-col gap-4">
                <div className="w-48 py-2 bg-gray-300 animate-pulse"></div>
                <div className="w-48 py-2 bg-gray-300 animate-pulse"></div>
                <div className="w-48 py-2 bg-gray-300 animate-pulse"></div>
                <div className="w-48 py-2 bg-gray-300 animate-pulse"></div>
                <div className="w-48 py-2 bg-gray-300 animate-pulse"></div>
            </div>
        </div>
    );
}